import React from 'react';
import PageHeader from '../components/PageHeader';
import useDocumentTitle from '../components/useDocumentTitle';

const NotFoundPage = () => {
    useDocumentTitle("Página no encontrada");
    return (
        <>
            <PageHeader tittle={"PÁGINA NO ENCONTRADA"} />
            <div className='md:px-5 px-1'>
                <div className='flex flex-col md:flex-row w-full'>
                    {/* La pagina que intentas acceder no existe, por favor verifica la url o vuelve al inicio. */}
                    <p className='text-center sm:w-[50%] py-6 mx-auto text-2xl sm:text-3xl font-light'>La página que intentas acceder no existe, por favor verifica la url o vuelve al inicio.</p>
                </div>
            </div>
        </>
    );
}
 
export default NotFoundPage;